export const DealXgSocketActions = {
    SOCKET_EVENT_RECEIVED: 'SHARED_DEALXG_WEBSOCKET/SOCKET_EVENT_RECEIVED',
    SOCKET_EVENT_IGNORED: 'SHARED_DEALXG_WEBSOCKET/SOCKET_EVENT_IGNORED',
    SHOW_DEAL_REFRESH_MODAL: 'SHARED_DEALXG_WEBSOCKET/SHOW_DEAL_REFRESH_MODAL',
    REFRESH_DEAL_REQUESTED: 'SHARED_DEALXG_WEBSOCKET/REFRESH_DEAL_REQUESTED'
} as const;

export type DealXgSocketActionType = (typeof DealXgSocketActions)[keyof typeof DealXgSocketActions];
